import React, { useMemo } from 'react';

import { PlusIcon } from '@vlabs/icons';
import { SearchListByNameInput } from '@vlabs/monokit/features/search-list-by-name';
import { PageHeader, usePageContext } from '@vlabs/monokit/shared/ui/page';
import { useHasPermission } from '@vlabs/permissions';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

import { routes } from '../../../app/routes';
import { CreateListButton } from '../buttons/CreateListButton';
import { ListListPageFilterMenuButton } from '../ListListPageFilterMenuButton';
import st from './ListListPageHeader.module.sass';

interface ListListPageHeaderProps {
  title?: string;
  titleItems?: React.ReactNode | React.ReactNode[];
}

function ListListPageHeader({
  title = undefined,
  titleItems = undefined,
}: ListListPageHeaderProps): React.JSX.Element {
  const { t } = useTranslation();
  const pageCtx = usePageContext();
  const history = useHistory();
  const canCreateList = useHasPermission('list', 'create');

  const $title = useMemo(() => (
    <div className={st.Title}>
      {pageCtx.getTitleComponent(title ?? t('list-list-page:title'))}
      {titleItems}
      <SearchListByNameInput
        disabled
        size={pageCtx.inputSize}
      />
    </div>
  ), [t, title, titleItems, pageCtx]);

  return (
    <PageHeader
      actions={(
        <React.Fragment>
          {!!canCreateList && (
            <CreateListButton
              icon={<PlusIcon />}
              onCreateList={(listId) => history.push(generatePath(routes.lists.read, { listId }))}
              size={pageCtx.buttonSize}
            />
          )}
          <ListListPageFilterMenuButton />
        </React.Fragment>
      )}
      title={$title}
    />
  );
}

export { ListListPageHeader };
